import axios from 'axios';
import toast from 'react-hot-toast';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({ baseURL: API_URL, withCredentials: true });

api.interceptors.response.use(
  r => r,
  err => {
    const status = err.response?.status;
    const msg    = err.response?.data?.error;
    // Rotas publicas (sem auth) — 401 nelas NAO deve redirecionar pra /login.
    // Motivo: o AuthContext chama /auth/me no mount de QUALQUER pagina para
    // checar se ha sessao ativa. Para usuarios nao logados, /auth/me retorna
    // 401 (correto). Se o path atual NAO estiver nessa lista, o redirect
    // dispara e joga o visitante pra /login mesmo que ele tenha acabado de
    // acessar /signup — loop indesejado.
    const publicPaths = ['/login', '/signup', '/forgot-password', '/reset-password', '/agendar', '/nps', '/reagendar'];
    const isPublicPath = publicPaths.some(p => window.location.pathname.startsWith(p));
    if (status === 401 && !isPublicPath) {
      window.location.href = '/login';
    } else if (status === 403) {
      toast.error(msg || 'Sem permissão para esta ação');
    } else if (status >= 500) {
      toast.error('Erro interno do servidor. Tente novamente.');
    }
    return Promise.reject(err);
  }
);

export const login           = d  => api.post('/auth/login', d);
export const logout          = () => api.post('/auth/logout');
export const getMe           = () => api.get('/auth/me');
export const impersonate     = id => api.post(`/auth/impersonate/${id}`);
export const stopImpersonating = () => api.post('/auth/stop-impersonating');
export const changePassword  = d  => api.put('/auth/change-password', d);
export const forgotPassword  = (email, tenant_slug) => api.post('/auth/forgot-password', tenant_slug ? { email, tenant_slug } : { email });
export const resetPassword   = (token, password) => api.post('/auth/reset-password', { token, password });
export const getTenants            = p       => api.get('/tenants', { params: p });
export const getTenantStats        = ()      => api.get('/tenants/stats');
export const getTenant             = id      => api.get(`/tenants/${id}`);
export const createTenant          = d       => api.post('/tenants', d);
export const updateTenant          = (id, d) => api.put(`/tenants/${id}`, d);
export const deleteTenant          = id      => api.delete(`/tenants/${id}`);
export const getTenantIntegrations = id      => api.get(`/tenants/${id}/integrations`);
export const updateTenantIntegration = (id, type, d) => api.put(`/tenants/${id}/integrations/${type}`, d);
export const getCurrentTenantSettings      = ()        => api.get('/tenant/settings');
export const updateCurrentTenantSettings   = d         => api.put('/tenant/settings', d);
// Cancelamento em 1 clique (Fase 3 parte 3)
export const cancelCurrentTenant           = ()        => api.post('/tenant/cancel');
export const revertCancelCurrentTenant     = ()        => api.post('/tenant/cancel/revert');
// Exportacao de dados — retorna Blob (JSON) via responseType
// Export de dados do tenant — apenas master. Antes havia self-serve em
// /tenant/export (removido). Master usa MasterTenantView pra gerar.
export const exportTenantDataByMaster      = (id)      => api.get(`/tenants/${id}/export`, { responseType: 'blob' });
export const getCurrentTenantIntegrations  = ()        => api.get('/tenant/integrations');
export const updateCurrentTenantIntegration = (type,d) => api.put(`/tenant/integrations/${type}`, d);
export const getUsers            = ()      => api.get('/users');
export const getUserRoles        = ()      => api.get('/users/roles');
export const createUser          = d       => api.post('/users', d);
export const updateUser          = (id, d) => api.put(`/users/${id}`, d);
export const getMyGCalendar      = ()      => api.get('/users/me/integration');
export const upsertGCalendar     = d       => api.put('/users/me/integration/google_calendar', d);
export const getGoogleAuthUrl    = ()      => api.get('/auth/google/connect');
export const disconnectGCalendar = ()      => api.post('/auth/google/disconnect');
export const syncGCalendarBacklog = ()     => api.post('/auth/google/sync-backlog');
export const testWhatsApp        = d       => api.post('/tenant/integrations/whatsapp/test', d);
export const getApptDashboard = ()      => api.get('/appointments/dashboard');
export const getAppointments  = p       => api.get('/appointments', { params: p });
export const createAppt       = d       => api.post('/appointments', d);
export const updateAppt       = (id, d) => api.put(`/appointments/${id}`, d);
export const deleteAppt       = id      => api.delete(`/appointments/${id}`);
export const getInvoices   = p       => api.get('/invoices', { params: p });
export const getAllInvoices = p       => api.get('/invoices/all', { params: p });
export const createInvoice = d       => api.post('/invoices', d);
export const generateInvoiceBatch = d => api.post('/invoices/batch', d);
export const confirmPayment = id     => api.put(`/invoices/${id}/confirm`);
export const cancelInvoice  = id     => api.put(`/invoices/${id}/cancel`);
// Comprovante PIX (Fase B) — tenant envia comprovante, master revisa pendentes
export const submitInvoiceProof = (id, file) => api.post(`/invoices/${id}/submit-proof`, { file });
export const getPendingReviewInvoices = () => api.get('/master/invoices/pending-review');
export const getPendingReviewCount    = () => api.get('/master/invoices/pending-review/count');
export const reviewInvoiceProof       = (id, action, notes) => api.post(`/master/invoices/${id}/review-proof`, { action, notes });
export const getPlans    = ()        => api.get('/plans');
export const getAllPlans  = ()        => api.get('/plans/all');
export const createPlan  = d         => api.post('/plans', d);
export const updatePlan  = (id, d)   => api.put(`/plans/${id}`, d);
export const deletePlan  = id        => api.delete(`/plans/${id}`);
export const getMasterSettings    = ()  => api.get('/master/settings');
export const updateMasterSettings = d  => api.put('/master/settings', d);
export const refreshExchangeRate  = ()  => api.post('/master/settings/exchange-rate/refresh');
export const testAsaasConnection  = (body = {}) => api.post('/master/settings/asaas/test', body);
export const diagnoseEmail        = ()       => api.get('/master/email/diagnose');
export const testEmail            = (to)     => api.post('/master/email/test', { to });
// Masters (usuários master do sistema)
export const getMasters           = ()           => api.get('/master/users');
export const createMaster         = d            => api.post('/master/users', d);
export const updateMaster         = (id, d)      => api.put(`/master/users/${id}`, d);
export const setMasterActive      = (id, active) => api.put(`/master/users/${id}/active`, { active });
// Leads (funil de vendas do master)
export const getLeads             = p            => api.get('/leads', { params: p });
export const getLeadsStats        = ()           => api.get('/leads/stats');
export const updateLead           = (id, d)      => api.put(`/leads/${id}`, d);
export const deleteLead           = id           => api.delete(`/leads/${id}`);
// Blog (CRUD master + leitura JSON pública)
export const getBlogPosts         = p            => api.get('/master/blog/posts', { params: p });
export const getBlogPost          = id           => api.get(`/master/blog/posts/${id}`);
export const createBlogPost       = d            => api.post('/master/blog/posts', d);
export const updateBlogPost       = (id, d)      => api.patch(`/master/blog/posts/${id}`, d);
export const deleteBlogPost       = id           => api.delete(`/master/blog/posts/${id}`);
// Captura pública de lead (landing) — não precisa auth
export const submitPublicLead     = d            => axios.post(`${API_URL}/public/leads`, d);
// Self-serve signup (Frente B) — cria tenant+admin+lead-converted
// automaticamente para plano Starter. Usado pela SignupPage.
export const publicSignup         = d            => axios.post(`${API_URL}/public/signup`, d);
// API Tokens do tenant (Enterprise feature: api_access)
export const listMyApiTokens      = ()           => api.get('/tenant/api-tokens');
export const createMyApiToken     = d            => api.post('/tenant/api-tokens', d);
export const revokeMyApiToken     = id           => api.delete(`/tenant/api-tokens/${id}`);
// Webhooks outgoing do tenant (Enterprise feature: webhooks)
export const listMyWebhooks            = ()      => api.get('/tenant/webhooks');
export const listMyWebhookEvents       = ()      => api.get('/tenant/webhooks/events');
export const listMyWebhookDeliveries   = (p)     => api.get('/tenant/webhooks/deliveries', { params: p });
export const createMyWebhook           = d       => api.post('/tenant/webhooks', d);
export const updateMyWebhook           = (id, d) => api.put(`/tenant/webhooks/${id}`, d);
export const deleteMyWebhook           = id      => api.delete(`/tenant/webhooks/${id}`);
export const getMyWebhookSecret        = id      => api.get(`/tenant/webhooks/${id}/secret`);

// Multi-unidade (Enterprise feature: multi_unit)
export const listUnits          = (p)     => api.get('/tenant/units', { params: p });
export const getUnit            = id      => api.get(`/tenant/units/${id}`);
export const createUnit         = d       => api.post('/tenant/units', d);
export const updateUnit         = (id, d) => api.put(`/tenant/units/${id}`, d);
export const deleteUnit         = id      => api.delete(`/tenant/units/${id}`);
export const assignUsersToUnit  = (id, d) => api.post(`/tenant/units/${id}/assign-users`, d);
export const assignServicesToUnit = (id, d) => api.post(`/tenant/units/${id}/assign-services`, d);
// Campanhas de desconto (master)
export const getCampaigns         = ()           => api.get('/campaigns');
export const getCampaign          = id           => api.get(`/campaigns/${id}`);
export const createCampaign       = d            => api.post('/campaigns', d);
export const updateCampaign       = (id, d)      => api.put(`/campaigns/${id}`, d);
export const setCampaignActive    = (id, active) => api.put(`/campaigns/${id}/active`, { active });
export const deleteCampaign       = id           => api.delete(`/campaigns/${id}`);
export const getNotifications     = ()  => api.get('/notifications');
export const getNotifCount        = ()  => api.get('/notifications/count');
export const markNotifRead        = id  => api.put(`/notifications/${id}/read`);
export const markAllNotifRead     = ()  => api.put('/notifications/read-all');
export const getAuditLogs = p => api.get('/audit-logs', { params: p });
export const uploadLogo = file => {
  const form = new FormData();
  form.append('logo', file);
  return api.post('/upload/logo', form);
};
export const masterUploadLogo = (tenantId, file) => {
  const form = new FormData();
  form.append('logo', file);
  return api.post(`/tenants/${tenantId}/logo`, form);
};
export const runJobs = () => api.get('/jobs/run');

// Serviços
export const getServices    = (p) => api.get('/services', { params: p });
export const createService  = d   => api.post('/services', d);
export const updateService  = (id, d) => api.put(`/services/${id}`, d);
export const deleteService  = id  => api.delete(`/services/${id}`);

// Horários de Atendimento
export const getBusinessHours  = ()  => api.get('/business-hours');
export const saveBusinessHours = d   => api.put('/business-hours', { hours: d });

// Trial Info
export const getTrialInfo = () => api.get('/tenant/trial-info');

// Perfis (roles) customizáveis — acesso tenant
export const getRoles       = ()        => api.get('/roles');
export const createRole     = d         => api.post('/roles', d);
export const updateRole     = (id, d)   => api.put(`/roles/${id}`, d);
export const deleteRole     = id        => api.delete(`/roles/${id}`);
export const getPermissions       = ()  => api.get('/permissions');
export const getMasterPermissions = ()  => api.get('/master/permissions');

// Perfis (roles) — acesso master por tenant
export const masterGetRoles    = (tid)          => api.get(`/tenants/${tid}/roles`);
export const masterCreateRole  = (tid, d)       => api.post(`/tenants/${tid}/roles`, d);
export const masterUpdateRole  = (tid, rid, d)  => api.put(`/tenants/${tid}/roles/${rid}`, d);
export const masterDeleteRole  = (tid, rid)     => api.delete(`/tenants/${tid}/roles/${rid}`);

// Onboarding
export const getOnboardingStatus = ()   => api.get('/tenant/onboarding');
export const completeOnboarding  = ()   => api.post('/tenant/onboarding/complete');
export const getTenantWidgetInfo = ()   => api.get('/tenant/widget');

// Agendamento Público (sem auth — URL direta)
export const getPublicTenant  = slug => axios.get(`${API_URL}/public/${slug}`);
export const getPublicSlots   = (slug, date, service_id) => axios.get(`${API_URL}/public/${slug}/slots`, { params: { date, service_id } });
export const getAvailableSlots = (slug, params) => axios.get(`${API_URL}/public/${slug}/slots`, { params });
export const createPublicBooking = (slug, d) => axios.post(`${API_URL}/public/${slug}/book`, d);
export const getPublicAppointment    = (slug, token) => axios.get(`${API_URL}/public/${slug}/appointment/${token}`);
export const cancelPublicAppointment = (slug, token) => axios.delete(`${API_URL}/public/${slug}/appointment/${token}`);
export const getPublicIntakeForm     = (slug, service_id) => axios.get(`${API_URL}/public/${slug}/intake-form`, { params: { service_id } });
export const joinWaitlist            = (slug, d) => axios.post(`${API_URL}/public/${slug}/waitlist`, d);
export const getPublicNPS            = token => axios.get(`${API_URL}/public/nps/${token}`);
export const respondPublicNPS        = (token, d) => axios.post(`${API_URL}/public/nps/${token}/respond`, d);
export const getPublicReschedule     = (slug, token) => axios.get(`${API_URL}/public/${slug}/reschedule/${token}`);
export const doPublicReschedule      = (slug, token, d) => axios.post(`${API_URL}/public/${slug}/reschedule/${token}`, d);

// Clientes / CRM
export const getClients       = p         => api.get('/clients', { params: p });
export const getClientById    = id        => api.get(`/clients/${id}`);
export const createClient     = d         => api.post('/clients', d);
export const updateClient     = (id, d)   => api.put(`/clients/${id}`, d);
export const deleteClient     = id        => api.delete(`/clients/${id}`);
export const syncClientsFromAppointments = () => api.post('/clients/sync');

// Lista de Espera
export const getWaitlist      = p  => api.get('/waitlist', { params: p });
export const notifyWaitlist   = id => api.put(`/waitlist/${id}/notify`);
export const removeFromWaitlist = id => api.delete(`/waitlist/${id}`);

// NPS
export const getNPS = p => api.get('/nps', { params: p });

// Formulários de Intake
export const getIntakeFormFields     = p         => api.get('/intake-forms', { params: p });
export const createIntakeFormField   = d         => api.post('/intake-forms', d);
export const updateIntakeFormField   = (id, d)   => api.put(`/intake-forms/${id}`, d);
export const deleteIntakeFormField   = id        => api.delete(`/intake-forms/${id}`);
export const getIntakeFormResponses  = apptId    => api.get(`/intake-forms/responses/${apptId}`);

// Depósitos
export const getDeposits             = p         => api.get('/deposits', { params: p });
export const confirmDeposit          = id        => api.put(`/deposits/${id}/confirm`);
export const refundDeposit           = id        => api.put(`/deposits/${id}/refund`);
export const getDepositSettings      = ()        => api.get('/tenant/deposit-settings');
export const updateDepositSettings   = d         => api.put('/tenant/deposit-settings', d);
// Chave PIX do tenant pra RECEBER sinais de clientes finais (distinto do
// PIX usado pra pagar a fatura AtendoApp).
export const getPixReceiveSettings   = ()        => api.get('/tenant/pix-settings');
export const updatePixReceiveSettings = d        => api.put('/tenant/pix-settings', d);
// Asaas do tenant (fluxo automatico)
export const getTenantAsaasSettings    = ()      => api.get('/tenant/asaas-settings');
export const updateTenantAsaasSettings = d       => api.put('/tenant/asaas-settings', d);
export const disconnectTenantAsaas     = ()      => api.delete('/tenant/asaas-settings');
// Confirmação automática (white-label — cria subconta por trás)
export const getAutoConfirmStatus      = ()      => api.get('/tenant/auto-confirm/status');
export const activateAutoConfirm       = d       => api.post('/tenant/auto-confirm/activate', d);
// Self-serve: tenant escolhe plano + gera fatura
export const getAvailablePlans         = ()      => api.get('/public/plans');
export const choosePlan                = d       => api.post('/tenant/choose-plan', d);

// Programa de Fidelidade
export const getLoyaltyProgram    = ()        => api.get('/loyalty');
export const createLoyaltyProgram = d         => api.post('/loyalty', d);
export const updateLoyaltyProgram = d         => api.put('/loyalty', d);
export const getLoyaltyRewards    = ()        => api.get('/loyalty/rewards');
export const createLoyaltyReward  = d         => api.post('/loyalty/rewards', d);
export const updateLoyaltyReward  = (id, d)   => api.put(`/loyalty/rewards/${id}`, d);
export const deleteLoyaltyReward  = id        => api.delete(`/loyalty/rewards/${id}`);
export const getLoyaltyClientPoints = phone   => api.get('/loyalty/points', { params: { phone } });
export const redeemLoyaltyReward  = d         => api.post('/loyalty/redeem', d);

// Pacotes e Vouchers
export const getPackages         = ()        => api.get('/packages');
export const createPackage       = d         => api.post('/packages', d);
export const updatePackage       = (id, d)   => api.put(`/packages/${id}`, d);
export const deletePackage       = id        => api.delete(`/packages/${id}`);
export const getClientPackages   = p         => api.get('/client-packages', { params: p });
export const issueClientPackage  = d         => api.post('/client-packages', d);
export const usePackageSession   = id        => api.put(`/client-packages/${id}/use`);

export default api;
